<form [formGroup]="guardianForm" novalidate>
    <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-2">Guardian {{data.item}}</h5>
    <div class="row mx-0 mt-4">
        <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
            <div class="form-floating mb-md-5 mb-4">
                <input type="text" class="form-control text-uppercase" formControlName="GuardianFirstName"
                    autocomplete="off" maxlength="60" id="gfname" placeholder="First Name"
                    (input)="onInputChange($event)" (blur)="spaceValidation($event, 'GuardianFirstName')">
                <label for="gfname">First Name</label>
            </div>
        </div>
        <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
            <div class="form-floating mb-md-5 mb-4">
                <input type="text" class="form-control text-uppercase" formControlName="GuardianLastName"
                    autocomplete="off" maxlength="60" id="glname" placeholder="Last Name"
                    (input)="onInputChange($event)" (blur)="spaceValidation($event, 'GuardianLastName')">
                <label for="glname">Last Name</label>
            </div>
        </div>
        <div class="col-lg-6 col-md-12 ps-md-2 px-0 h-90">
            <div class="pe-md-5 mb-md-5 mb-4">
                <div class="input-group border form-floating pan-auto">
                    <ng-autocomplete [data]="countryList" [searchKeyword]="codeKeyword" placeholder=""
                        [itemTemplate]="itemTemplate" [(ngModel)]="countryCode" [ngModelOptions]="{standalone: true}"
                        name="source" mdbInput autocomplete="on" (inputChanged)='telcode($event)'
                        (input)='numericOnly($event)' (closed)="checkCode()" (selected)='selectCodeEvent($event)'
                        (keydown)="restrictEnter($event)" [notFoundTemplate]="notFoundTemplate"
                        #countryCodeInput="ngModel" id="showw">
                    </ng-autocomplete>

                    <label [ngClass]="countryCode ? 'pin-top':''">Code</label>
                    <ng-template #itemTemplate let-item>
                        <a [innerHTML]="item.TeleCode"></a> <a [innerHTML]="item.Name"></a>
                    </ng-template>

                    <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound"></div>
                    </ng-template>
                    <input type="text" (paste)="(false)"
                        class="form-control my-1 me-2 border-top-0 border-end-0  border-bottom-0 pe-0 ps-3 py-0"
                        autocomplete="off" (input)='numericOnly($event)' maxlength="15" id="GuardianMobile"
                        autocomplete="off" formControlName="GuardianMobile" placeholder="Enter Mobile Number">
                    <label for="GuardianMobile" class="left">Mobile Number.</label>
                </div>
                <!-- <div class="ms-3 mt-2" *ngIf="countryCodeError || (countryCodeInput.invalid && countryCodeInput.touched)"
                        [ngClass]="{'text-danger': countryCodeError || (countryCodeInput.invalid && countryCodeInput.touched)}">
                        <span class="small">Valid Country Tele Code is required.</span>
                    </div> -->

                <div *ngIf="guardianForm.controls.GuardianMobile.touched && guardianForm.controls.GuardianMobile.errors"
                    class="ms-3 mt-2">
                    <span class="small text-danger">Mobile number must be at least 7 digits.</span>
                </div>


            </div>
        </div>

        <div class="col-lg-6 col-md-12 pe-md-5 ps-md-2 px-0 h-90 mb-2">
            <div class="form-floating mb-md-5 mb-4">
                <input type="email" class="form-control" (paste)="(false)" id="Gemail" formControlName="GuardianEmail"
                    (input)="emailOnly($event)" placeholder="Enter Email ID" autocomplete="off">
                <label for="Gemail">Email</label>
                <div *ngIf="guardianForm.controls.GuardianEmail.touched && guardianForm.controls.GuardianEmail.errors"
                    class="ms-3 mt-2">
                    <span class="small text-danger"
                        *ngIf="guardianForm.controls.GuardianEmail.errors['invalidEmailAddress']">Please provide email
                        in correct format.</span>
                </div>
            </div>
        </div>
        <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
            <div class="form-floating mb-md-5 mb-4">
                <select class="form-select"
                    [ngClass]="guardianForm.controls.GuardianRelationship.value ? 'optionValue' : ''"
                    formControlName="GuardianRelationship" id="gr">
                    <option [value]="list.Value" *ngFor="let list of guardianList; let i = index">{{list.Name}}</option>
                </select>
                <label [ngClass]="guardianForm.controls.GuardianRelationship.value ? '':'form-select-label'"
                    for="gr">Relationship with Applicant<span class="text-danger">*</span></label>
            </div>
        </div>

        <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
            <div class="form-floating mb-md-5 mb-4">
                <select class="form-select" formControlName="GuardianIdProof" id="gId">
                    <option [value]="list.value" *ngFor="let list of guardianIDs; let i = index">{{list.name}}</option>
                </select>
                <label [ngClass]="guardianForm.controls.GuardianIdProof.value ? '':'form-select-label'" for="nId">ID Proof</label>
            </div>
        </div>

        <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
            <div class="form-floating mb-md-5 mb-4">
                <input type="text" class="form-control" formControlName="GuardianIdProofNumber" autocomplete="off"
                    maxlength="20" id="gproof" placeholder="Guardian Name" appAlphanumeric>
                <!-- <label for="nproof">Id proof number<span class="text-danger">*</span></label> -->
                <label for="nproof">
                    {{ guardianForm.controls.GuardianIdProof?.value === 'A'
                    ? 'ID Proof Number (last 4 digits)'
                    : 'ID Proof Number' }}
                </label>
            </div>
        </div>

    </div>
</form>